import { render } from "./LoadScreen.vue?vue&type=template&id=06510be8&scoped=true"
import script from "./LoadScreen.vue?vue&type=script&lang=js"
export * from "./LoadScreen.vue?vue&type=script&lang=js"

import "./LoadScreen.vue?vue&type=style&index=0&id=06510be8&lang=sass&scoped=true"

import exportComponent from "C:\\Riman\\Web\\Alex\\ars\\front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06510be8"]])

export default __exports__